import { Dialog, DialogContent } from '@mui/material';
import { useEffect } from 'react';
import { useCiudadesStore } from '../../stores/ciudades/ciudades.store';
import { useEstadosStore } from '../../stores/estados/estados.store';
import {
  usePersonalRecibeStore,
  type RegistrarPersonaRecibe
} from '../../stores/personal-recibe/personal-recibe.store';
import PersonalRecibeForm from './PersonaRecibeForm';

interface PersonalRecibeAddDialogProps {
  open: boolean;
  onClose: () => void;
  onAddSuccess: (newId: number) => void;
}

const PersonalRecibeAddDialog = ({ open, onClose, onAddSuccess }: PersonalRecibeAddDialogProps) => {
  const { nuevo, registrar } = usePersonalRecibeStore();

  const { actives: ciudades, cargarActivas: cargarCiudades } = useCiudadesStore();
  const { actives: estados, cargarActivos: cargarEstados } = useEstadosStore();

  useEffect(() => {
    nuevo();
    cargarCiudades();
    cargarEstados();
  }, []);

  const handleSave = async (values: RegistrarPersonaRecibe) => {
    const result = await registrar(values);
    if (result) {
      onAddSuccess(result);
    }
    return result;
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent>
        <PersonalRecibeForm
          esAgregar={true}
          ciudades={ciudades}
          estados={estados}
          onSave={handleSave}
          onClose={onClose}
          reloadCiudades={cargarCiudades}
        />
      </DialogContent>
    </Dialog>
  );
};

export default PersonalRecibeAddDialog;
